module.exports = __webpack_public_path__ + "crm_static/img/img_idcard1.7fca9e53.png";